import React, { useState } from 'react'
import './adminStyles.css'
import AdminSidebar from './Sidebar/AdminSidebar'
import AdminHeader from './Header/AdminHeader'
import { IoChevronBack } from "react-icons/io5";
import { useNavigate } from 'react-router-dom';
import admn_tools_icon  from '../../assets/admin/admn_tools_icon.webp'

const IssuersDetails = () => {
    const Navigate = useNavigate();
    const [status, setStatus] = useState("New");
    const [reviewer, setReviewer] = useState("Admin Alice 221");
    const [approverStatus, setApproverStatus] = useState('')

    const handleStatus = (e) => {
        console.log(e.target.innerText.toLowerCase(), "iiuh");
        setStatus(e.target.innerText.toLowerCase());
    };

    const handleReviewer = (e) => {
        console.log(e.target.innerText.toLowerCase(), "setReviewer");
        setReviewer(e.target.innerText.toLowerCase());
    };

    const handleApproverStatus = (value) => {
        setApproverStatus(value)
        Navigate('/admin/issuers')
    };

  return (
      <>
          <>
              <AdminHeader />

              <main className="main_flx userMang_main">
                  <AdminSidebar />

                  <div className="right_wrap pb-4">
                      <div>
                        <div onClick={() => Navigate(-1)} className='back_common_wrp'>
                           <IoChevronBack /> Back
                        </div>
                        
                        <div className='issudt_cnt_wrp'>
                            <div className='issdt_row'>
                                <div className='issdt_colleft'>
                                    <div className='issdt_Infrwrp'>
                                        <h3 className='inspge_title'>Issuer Information</h3>
                                        <div className='issdt_Infrcrd'>
                                            <div className='frm_grp_label'>
                                                <label>First Name</label> <span>John</span>
                                            </div>
                                            <div className='frm_grp_label'>
                                                <label>Last Name</label> <span>Doe</span>
                                            </div>
                                            <div className='frm_grp_label'>
                                                <label>Country</label> <span>Singapore</span>
                                            </div>
                                            <div className='frm_grp_label'>
                                                <label>Mobile Number</label> <span>+65 1234 5678</span>
                                            </div>
                                            <div className='frm_grp_label'>
                                                <label>Email</label> <span>joe@example.com</span>
                                            </div>
                                            <div className='frm_grp_label'>
                                                <label>Category</label> <span>Real Estate</span>
                                            </div>
                                            <div className='frm_grp_label frm_grp_textarea'>
                                                <label>Message</label>
                                                <textarea>We are interested in listing our property-backed token on Assetly.</textarea>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='issdt_metdtInfrwrp'>
                                        <h3 className='inspge_title'>System Metadata</h3>
                                        <div className='issdt_metdtrcrd'>
                                            <div className='metdt_grp_label'>
                                                <label>Issuer ID</label> <span>ISS-0001</span>
                                            </div>
                                            <div className='metdt_grp_label'>
                                                <label>Submission Date</label> <span>21 Sep 2025, 14:32 GMT</span>
                                            </div>
                                            <div className='metdt_grp_label'>
                                                <label>IP Address</label> <span>192.168.0.1</span>
                                            </div>
                                            <div className='metdt_grp_label'>
                                                <label>Submission Source</label> <span>Institutional Contact Form</span>
                                            </div>
                                            <div className='metdt_grp_label'>
                                                <label>Last Updated By</label> <span>Admin Alice, 22 Sep 2025</span>
                                            </div>
                                            <div className='metdt_grp_label metdt_grp_select admin_select_cmmn'>
                                                <label>Status</label>
                                                  <div className="status_select_main admin_slct_main">
                                                      <div className="dropdown">
                                                          <button
                                                              className="btn btn-secondary dropdown-toggle"
                                                              type="button"
                                                              id="dropdownMenuButton1"
                                                              data-bs-toggle="dropdown"
                                                              aria-expanded="false"
                                                          >
                                                              <span>{status}</span>
                                                          </button>
                                                          <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1" >
                                                              <li onClick={handleStatus}> New </li>
                                                              <li onClick={handleStatus}> Approved </li>
                                                              <li onClick={handleStatus}> Contacted </li>
                                                              <li onClick={handleStatus}> Reviewed </li>
                                                          </ul>
                                                      </div>
                                                  </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='issdt_colright'>
                                    <div className='issdt_admntlswrp'>
                                        <h3 className='inspge_title issdt_admntitle'>Admin Tools</h3>
                                        <div className='issdt_Infrcrd issdt_admntlscrd'>
                                           <div className='admn_tools_icon'>
                                                <img src={admn_tools_icon} alt='admn_tools_icon' />
                                                <h5>Admin Tools</h5>
                                           </div>
                                           <div className='metdt_grp_label admn_select_col admin_select_cmmn'>
                                                <label>Assign Reviewer</label>
                                                  <div className="status_select_main admin_slct_main admin_slct_col">
                                                      <div className="dropdown">
                                                          <button
                                                              className="btn btn-secondary dropdown-toggle"
                                                              type="button"
                                                              id="dropdownMenuButton1"
                                                              data-bs-toggle="dropdown"
                                                              aria-expanded="false"
                                                          >
                                                              <span>{reviewer}</span>
                                                          </button>
                                                          <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1" >
                                                              <li onClick={handleReviewer}> Admin Alice 221  </li>
                                                              <li onClick={handleReviewer}> Admin BOB </li>
                                                              <li onClick={handleReviewer}> Admin Jon </li>
                                                              <li onClick={handleReviewer}> @Admin223 </li>
                                                              <li onClick={handleReviewer}> Admin 001 </li>
                                                          </ul>
                                                      </div>
                                                  </div>
                                            </div>
                                            <div className='admintl_grp_label admintl_grp_textarea'>
                                                <label>Add Internal Notes</label>
                                                <textarea></textarea>
                                            </div>
                                            <div className='attchd_file_grp'>
                                                <label>Attached Files</label>
                                                  <div className='common_chkbox_main'>
                                                      <div className='common_chkbox_wrp'>
                                                          <p>Company Policies.pdf</p>
                                                          <div class="form-check">
                                                              <input class="form-check-input" type="checkbox" value="" id="CompanyPolicies" />
                                                          </div>
                                                      </div>
                                                  </div>
                                                  <div className='common_chkbox_main'>
                                                      <div className='common_chkbox_wrp'>
                                                          <p>Company Dec.pdf</p>
                                                          <div class="form-check">
                                                              <input class="form-check-input" type="checkbox" value="" id="CompanyDec" />
                                                          </div>
                                                      </div>
                                                  </div>
                                                  <div className='common_chkbox_main'>
                                                      <div className='common_chkbox_wrp'>
                                                          <p>Issuer Advantages.pdf</p>
                                                          <div class="form-check">
                                                              <input class="form-check-input" type="checkbox" value="" id="IssuerAdvantages" />
                                                          </div>
                                                      </div>
                                                  </div>
                                                  <div className='common_chkbox_main common_chkbox_main_last'>
                                                      <div className='common_chkbox_wrp'>
                                                          <p>welcome.pdf</p>
                                                          <div class="form-check">
                                                              <input class="form-check-input" type="checkbox" value="" id="welcome" />
                                                          </div>
                                                      </div>
                                                  </div>
                                                  <div className='apprvl_btn_wrp'>
                                                    <button 
                                                    onClick={() => {handleApproverStatus('Approve')}} 
                                                    className={`approve ${approverStatus === 'Approve' ? 'activeApprove' : '' }`} 
                                                    >Approve Issuer</button>

                                                    <button
                                                    onClick={() => {handleApproverStatus('Reject')}} 
                                                    className={`reject ${approverStatus === 'Reject' ? 'activeReject' : '' }`} 
                                                    >Reject/ Archive</button>
                                                  </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                      </div>
                      {/* <div className="dsh_footer_wrap">
                          <Footer />
                      </div> */}
                  </div>
              </main>
          </>
      </>
  )
}

export default IssuersDetails